import Resource from 'rest-resource'
import { flatten } from 'lodash'

export default class BaseResource extends Resource {
    static async filter(filterArgs) {
        const results = await this.list({ query: filterArgs })
        return results
    }

    /**
     * Allow a custom Resource.all() method to recursively call list() except with all other pages
     * @param options
     */
    static async all(options) {
        let content = (await this.filter(options)) || {}
        let data = (content.response || {}).data
        let pages

        let allResources = {
            [data.page]: content.resources,
        }

        // More pages
        let otherPages = []
        if (data.next) {
            const count = parseInt(data.count) || 1
            const pageSize = data.results ? data.results.length : 1
            pages = Math.ceil(count / pageSize) || 1
        }
        if (pages > 1) {
            for (let i = 2; i <= pages; i++) {
                otherPages.push(i)
            }
        }

        // get query string to build pages
        let query = new URL(data.url).searchParams
        let queryObject = {}
        query.forEach((value, key) => {
            queryObject[key] = value
        })

        // Get other pages
        let promises = otherPages.map((page) => {
            let thisPageQuery = Object.assign({}, queryObject, { page })
            return this.list(Object.assign({}, options, { query: thisPageQuery })).then((res) => {
                allResources[page] = res.resources
            })
        })

        await Promise.all(promises)
        return flatten(Object.values(allResources))
    }
}
